import { render, staticRenderFns } from "./Jury.vue?vue&type=template&id=8d7cd6c8&scoped=true"
import script from "./Jury.vue?vue&type=script&lang=js"
export * from "./Jury.vue?vue&type=script&lang=js"
import style0 from "./Jury.vue?vue&type=style&index=0&id=8d7cd6c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d7cd6c8",
  null
  
)

export default component.exports